export const API_URL_ENV = process.env.VUE_APP_API_URL
export const API_PAYMENTS_URL_ENV = process.env.VUE_APP_API_PAYMENTS_URL
export const API_AUTH_URL_ENV = process.env.VUE_APP_API_AUTH_URL
export const ALGOLIA_APP_ID = process.env.VUE_APP_ALGOLIA_APP_ID
export const ALGOLIA_API_KEY = process.env.VUE_APP_ALGOLIA_API_KEY
export const ALGOLIA_INDEX_NAME = process.env.VUE_APP_ALGOLIA_INDEX_NAME
export const APP_SITE_ID = process.env.VUE_APP_APP_SITE_ID
export const ADSPOTS = process.env.VUE_APP_ADSPOTS
export const ADSPOTS_PDP = process.env.VUE_APP_PDP
export const ENABLE_PDP = process.env.VUE_APP_ENABLE_PDP
export const ENABLE_PHRASE = process.env.VUE_APP_ENABLE_PHRASE